import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 className="title">Aana Stall</h1>
        
        {/* Two images from public folder */}
            <img src='image.png' alt='image1'/>
        {/* Footer Text */}
        <p className="footer">
          Made by <strong>Joydeep Saha</strong>, Final Year CS Student at BITS-Pilani
        </p>
      </header>
    </div>
  );
}

export default App;
